import ls from 'local-storage';

const TOKEN_KEY = 'picker_access_token';
const EXP_KEY = 'picker_access_token_exp';

export async function ensurePickerToken() {
    const token = ls.get(TOKEN_KEY);
    const exp = ls.get(EXP_KEY);

    if (token && exp && Date.now() < exp - 60000) {
        return true; // still valid
    }

    try {
        const resp = await fetch('/api/auth/picker-token', {
            method: 'GET',
            credentials: 'same-origin'
        });

        if (!resp.ok) return false;

        const data = await resp.json();

        ls.set(TOKEN_KEY, data.accessToken);
        ls.set(EXP_KEY, new Date(data.expiresUtc).getTime());

        return true;
    } catch (e) {
        console.error('[pickerAuth] failed to fetch picker token', e);
        return false;
    }
}

export function getPickerToken() {
    return ls.get(TOKEN_KEY);
}

export function isPickerTokenExpired() {
    const exp = ls.get(EXP_KEY);
    return !exp || Date.now() >= exp;
}

export function clearPickerToken() {
    localStorage.removeItem('picker_access_token');
    localStorage.removeItem('picker_access_token_exp');
}

